import { Controller } from "@hotwired/stimulus"

// A task list in the side panel (TaskListPanelsController). Checking a task off (or back on) goes through the same
// endpoints as the Tasks page; a task's title opens that task in the task pane, in this same panel, with a way back to
// the list. A plain click does both; cmd/ctrl/shift/middle click on a title still opens the task in the list page.
export default class extends Controller {
    static values = { listId: Number, editable: Boolean }

    async toggle(event) {
        const button = event.currentTarget
        const row = button.closest("[data-task-id]")
        const done = button.getAttribute("aria-checked") !== "true"
        this._mark(row, button, done)
        if (!(await this._post(row.dataset.taskId, done ? "complete" : "uncomplete"))) this._mark(row, button, !done)
    }

    // Fold or unfold what is under a task or heading. Editors share the list's own collapsed state (the Tasks page folds
    // the same way); anyone else folds it for themselves only.
    toggleCollapse(event) {
        const row = event.currentTarget.closest("[data-task-id]")
        const folded = row.dataset.collapsed !== "true"
        row.dataset.collapsed = String(folded)
        event.currentTarget.setAttribute("aria-expanded", String(!folded))
        if (this.editableValue) this._send(`/tasks/${row.dataset.taskId}`, "PATCH", { collapsed: String(folded) })
    }

    openTask(event) {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button === 1) return

        const link = event.currentTarget
        event.preventDefault()
        window.dispatchEvent(new CustomEvent("jane:open-panel", {
            detail: { url: `/tasks/${link.dataset.taskId}/panel?from_list=${this.listIdValue}`, title: link.dataset.taskTitle, icon: "bi-check2-square", label: "Task" }
        }))
    }

    _mark(row, button, done) {
        button.setAttribute("aria-checked", String(done))
        row.classList.toggle("is-done", done)
    }

    _post(taskId, action) {
        return this._send(`/tasks/${taskId}/${action}`, "POST")
    }

    async _send(url, method, params = {}) {
        try {
            const response = await fetch(url, {
                method,
                credentials: "same-origin",
                headers: { Accept: "application/json", "Content-Type": "application/x-www-form-urlencoded", "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "" },
                body: new URLSearchParams({ list_id: this.listIdValue, ...params })
            })
            return response.ok
        } catch (_error) {
            return false
        }
    }
}
